export default {"src":"/_next/static/media/arrow-forward.6d1ed183.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};